/**
 * Path helpers for M2 signup wizard and onboarding-related layout (sidebar, Productlane).
 * Router basename matches App.js / index.jsx (local `/` vs production `/dashboard/`).
 */

/** Regex path for activation mode: block deep links away from Home (except `share` step). */
export const ACTIVATION_NAV_BLOCK_PATH =
  '/(payments|contacts|subscriptions|forms|elements|funds|payouts|events|settings|embeds|opt-in|tickets|fundraisers|coming-soon)';

export const CREATE_ORGANIZATION_INTENT = 'create-organization';

/** A deliberate route opt-in for an authenticated user creating another org. */
export function isCreateOrganizationIntent(search = '') {
  try {
    return new URLSearchParams(search).get('intent') === CREATE_ORGANIZATION_INTENT;
  } catch {
    return false;
  }
}

/**
 * M2 Clerk gate: user is on the org signup wizard route.
 * Mirrors legacy checks (basename + absolute-style path).
 */
export function isOnboardingRoutePath(pathname, routerBasename) {
  return (
    pathname.startsWith('/onboarding') || pathname.startsWith(routerBasename + 'onboarding')
  );
}

/**
 * Productlane: treat as onboarding context if URL contains `/onboarding` or basename-prefixed wizard path.
 */
export function pathnameTouchesOnboardingForProductlane(pathname, routerBasename) {
  return (
    pathname.includes('/onboarding') || pathname.startsWith(routerBasename + 'onboarding')
  );
}

/** Steps where the Productlane widget should stay hidden (full-bleed activation UX). */
const PRODUCTLANE_HIDDEN_ONBOARDING_STEPS = new Set([
  'stripe_connect',
  'script_install',
  'create_form',
]);

/**
 * Hide Productlane during Stripe Connect onboarding, script install, and guided form creation.
 * Those flows run on Home (`/`) — not under `/onboarding` — so pathname checks alone are not enough.
 */
export function shouldHideProductlaneForOnboardingStep(onboardingCurrentStep) {
  return (
    typeof onboardingCurrentStep === 'string' &&
    PRODUCTLANE_HIDDEN_ONBOARDING_STEPS.has(onboardingCurrentStep)
  );
}
